import { createAction, props } from '@ngrx/store';

export const REFETCH_ENTITY_ADDRESS = createAction(
  '[AddressRefetch] REFETCH_ENTITY_ADDRESS',
  props<{ payload: { addressId: string; entityId: string; campaignId: string; delay?: number } }>()
);

